const categories = {
  2426: {
    carouselCatId: 51206,
    title: "kylie_plp_carousel_title",
    subtitle: "kylie_plp_carousel_subtitle"
  }
};

export default categories;
